import { BaseComponent2 } from '../../_common/client/base-component2';

export class ProductAdviceComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_product-advice';

    public async onReloadComponentEvent(): Promise<void> {
        if (!this.isPresent()) return;

        o_global.eventQBus.emit('assets.focusseddialog.init', window.location.search, window.location.href, this.getRootElement());
    }
}
